import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getCheckoutUrl } from '../lib/utm';
const CHECKOUT_URL = 'https://axe-ia-tech.impultienda.ar/checkout';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const checkoutUrl = getCheckoutUrl(CHECKOUT_URL);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky bar after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-144">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 shadow-[0_-10px_30px_rgba(0,0,0,0.05)] p-4 md:hidden" data-id="element-145">
          <div className="flex items-center justify-between gap-4 max-w-5xl mx-auto" data-id="element-146">
            <div className="flex flex-col" data-id="element-147">
              <div className="flex items-center gap-2" data-id="element-148">
                <span className="text-slate-400 line-through text-xs" data-id="element-149">
                  USD 242
                </span>
                <span className="text-green-600 text-xs font-bold" data-id="element-150">
                  Ahorrás USD 225
                </span>
              </div>
              <div className="text-xl font-black text-blue-800" data-id="element-151">USD 17</div>
            </div>
            <a href={checkoutUrl} className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white font-bold px-6 py-3 rounded-xl shadow-lg flex items-center gap-2 whitespace-nowrap" data-id="element-152">
              Descargar Ahora <ArrowRight className="w-4 h-4" data-id="element-153" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}